import {Injectable} from '@angular/core';
import {OktaAuth, UserClaims} from "@okta/okta-auth-js";
import {BehaviorSubject, from} from "rxjs";
import {AccessControllerService, Role} from "falcon-api";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public role : BehaviorSubject<Role> = new BehaviorSubject(new Role());
  public userClaims?: UserClaims;

  constructor(private oktaAuth: OktaAuth, private accessController : AccessControllerService) {

  }

  async isLoggedIn(): Promise<boolean> {
    return await this.oktaAuth.isAuthenticated()
  }

  getTokenObj(): any {
    const tokenString = localStorage.getItem('okta-token-storage');
    const tokenObj = tokenString ? JSON.parse(tokenString) : {};
    return tokenObj;
  }

  getAccessToken(): string | undefined {
    return this.getTokenObj()?.accessToken?.accessToken;
  }

  getUserInfo() {
    return from(this.oktaAuth.getUser());
  }

  getGroups(): string[] {
    return this.getTokenObj()?.accessToken?.claims?.groups;
  }

  getAccessRole() {
    this.accessController.getRoleByOktaRoleList(this.getGroups()).subscribe(value => {
      this.role.next(value);
    });
  }

  getAccessPermissions(role : Role) : string[] {
    let accessPermissionList : string[] | undefined = new Array();

    role.rolePermission?.forEach((rolePermission) => {
      if(rolePermission.permission?.enabled) {
        accessPermissionList?.push(rolePermission.permission?.permissionName!);
      }
    });
    return accessPermissionList;
  }
}
